import { Link } from "react-router-dom";
import { Facebook, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative bg-carbon border-t border-white/10 pt-16 pb-8 px-6 md:px-10" data-testid="footer">
      <div className="max-w-[1600px] mx-auto grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-3">
          <div className="font-display uppercase text-3xl md:text-4xl leading-[0.9] tracking-tighter">
            Mids<span className="text-volt">Tuning.</span>
          </div>
          <p className="font-body text-white/40 mt-4 max-w-md text-sm">
            Precision ECU remapping and road-verified tuning across Nottingham & Derby.
          </p>
        </div>

        <div className="col-span-6 md:col-span-3 flex flex-col gap-4 font-mono text-xs uppercase tracking-widest text-white/60">
          <div className="text-white/30 mb-2">Services</div>
          <Link to="/services/mobile-remapping" className="hover:text-volt" data-testid="footer-mobile-remapping-link">Mobile Remapping</Link>
          <Link to="/services/stage-1-remap" className="hover:text-volt">Stage 1 Remap</Link>
          <Link to="/services/stage-2-remap" className="hover:text-volt">Stage 2 Remap</Link>
          <Link to="/services/stage-3-remap" className="hover:text-volt">Stage 3 & Custom</Link>
          <Link to="/services/dpf-egr-removal" className="hover:text-volt">DPF / EGR / AdBlue</Link>
          <Link to="/services/dpf-cleaning" className="hover:text-volt" data-testid="footer-dpf-cleaning-link">DPF Cleaning</Link>
          <Link to="/services/gearbox-tuning" className="hover:text-volt">Gearbox Tuning</Link>
          <Link to="/services/diagnostics" className="hover:text-volt">Diagnostics</Link>
          <Link to="/services/car-key-programming" className="hover:text-volt">Car Keys &amp; Fobs</Link>
        </div>

        <div className="col-span-6 md:col-span-3 flex flex-col gap-4 font-mono text-xs uppercase tracking-widest text-white/60">
          <div className="text-white/30 mb-2">Explore</div>
          <Link to="/prices" className="hover:text-volt" data-testid="footer-prices-link">Prices</Link>
          <Link to="/car-remapping/nottingham" className="hover:text-volt">Remapping Nottingham</Link>
          <Link to="/car-remapping/derby" className="hover:text-volt">Remapping Derby</Link>
          <Link to="/car-remapping/leicester" className="hover:text-volt" data-testid="footer-leicester-link">Remapping Leicester</Link>
          <Link to="/remapping-near-me" className="hover:text-volt" data-testid="footer-nearme-link">Remapping Near Me</Link>
          <Link to="/areas/east-midlands" className="hover:text-volt" data-testid="footer-east-midlands-link">East Midlands</Link>
          <Link to="/areas" className="hover:text-volt">All Areas</Link>
          <Link to="/car-keys" className="hover:text-volt" data-testid="footer-carkeys-link">Car Keys by Area</Link>
          <Link to="/remap" className="hover:text-volt" data-testid="footer-vehicles-link">Vehicle Remaps</Link>
          <Link to="/blog" className="hover:text-volt" data-testid="footer-blog-link">Journal</Link>
          <a href="/#faq" className="hover:text-volt">FAQ</a>
          <a href="/book" className="hover:text-volt">Book</a>
        </div>

        <div className="col-span-6 md:col-span-3 flex flex-col gap-4 font-mono text-xs uppercase tracking-widest text-white/60">
          <div className="text-white/30 mb-2">Contact</div>
          <span>Mobile service · we come to you</span>
          <span>Coverage · Notts · Derby · East Midlands</span>
          <a href="tel:07523386312" className="text-volt hover:text-white transition-colors">07523 386312</a>
          <a
            href="https://wa.me/447523386312"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#25D366] hover:text-white inline-flex items-center gap-2 transition-colors"
            data-testid="footer-whatsapp-link"
          >
            <MessageCircle className="w-3.5 h-3.5" strokeWidth={1.5} />
            WhatsApp
          </a>
          <a
            href="https://www.facebook.com/people/Mids-Tuning/61592316213895/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-volt inline-flex items-center gap-2"
            data-testid="footer-facebook-link"
          >
            <Facebook className="w-3.5 h-3.5" strokeWidth={1.5} />
            Facebook
          </a>
        </div>

        <div className="col-span-12 border-t border-white/10 mt-12 pt-6 flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] uppercase tracking-widest text-white/40">
          <span>© {new Date().getFullYear()} Mids Tuning</span>
          <span>Road-verified · Fully insured · Data-logged</span>
          <span className="text-volt">◉ Nottingham × Derby</span>
        </div>
      </div>
    </footer>
  );
}
